module.exports = __webpack_public_path__ + "img/logo.4261aae9.png";